import { Box, Breadcrumbs, Link, Tab, Tabs, Typography } from "@mui/material";
import { useFuncionariosCadastroViewModel } from "../../viewModels/funcionarios_cadastro_view_model";
import { BackButton } from "../../../../../common/components/back_button";
import { AvaliarTreinamentoModal } from "./components/avaliar_treinamento_modal";
import { CadastroAfastamentoModal } from "./components/cadastro_afastamento_modal";
import { CadastroDependenteModal } from "./components/cadastro_dependente_modal";
import { CadastroDocumentoModal } from "./components/cadastro_documento_modal";
import { CadastroEventoModal } from "./components/cadastro_evento_modal";
import { CadastroFeriasModal } from "./components/cadastro_ferias_modal";
import { CadastroTreinamentoModal } from "./components/cadastro_treinamento_modal";
import { TabControlePatrimonioContent } from "./components/tab_controle_patrimonio_content";
import { TabDocumentosContent } from "./components/tab_documentos_content";
import { TabHabilidadesContent } from "./components/tab_habilidades_content";
import { TabInformacoesGeraisContent } from "./components/tab_informacoes_gerais_content";
import { TabTreinamentosContent } from "./components/tab_treinamentos_content";
import { CadastroHabilidadeModal } from "./components/cadastro_habilidade_modal";
import { CadastroHabilidadeItemModal } from "./components/cadastro_habilidade_item_modal";
import { CadastroControlePatrimonioModal } from "./components/cadastro_controle_patrimonio_modal";
import { CadastroCentroCustoSecundarioModal } from "./components/cadastro_centro_custo_secundario_modal";
import { RelatorioTreinamentoModal } from "./components/relatorio_treinamento_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";
import { Link as LinkTo } from "react-router";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { CentroCustoDrawer } from "../../../../../common/components/drawers_api/drawers/centro_custo_drawer";
import { MotivoDemissaoDrawer } from "../../../../../common/components/drawers_api/drawers/motivo_demissao_drawer";
import { HeaderStatus } from "./components/header_status";
import { CadastroBiometriaFacialModal } from "./components/cadastro_biometria_Facial";
import { TabBiometriaFacialContent } from "./components/tab_controle_biometria_facial";
import { VisualizacaoBiometriaModal } from "./components/visualizacao_biometria_modal";
import { VisualizacaoGryfoAuditaModal } from "./components/visualizacao_gryfo_audit_modal";
import { JobWaiterModal } from "../../../../../common/components/job_waiter_modal";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * FuncionariosCadastro
 */

export const FuncionariosCadastro = () => {
  const viewModel = useFuncionariosCadastroViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          leftSlot={
            <div className="w-full flex flex-row gap-2">
              {viewModel.funcionario && (
                <div className="w-full h-full flex flex-col justify-center text-black dark:text-white">
                  <span className="mx-1 font-bold text-md">
                    {viewModel.funcionario.nome}
                  </span>
                  <span className="mx-1 font-light text-xs">
                    {viewModel.funcionario.cargo}
                  </span>
                </div>
              )}
            </div>
          }
          centerSlot={
            <div className="w-full h-full flex flex-row justify-center items-center gap-2">
              {viewModel.isCreated && (
                <HeaderStatus status={viewModel.status} />
              )}
            </div>
          }
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="flex flex-row gap-2">
                {viewModel.isCreated && (
                  <div className="w-[6rem]">
                    <PrimaryButton
                      buttonColor="red"
                      onClick={viewModel.handleExcluirFuncionario}
                    >
                      Excluir
                    </PrimaryButton>
                  </div>
                )}
                {viewModel.isCreated && (
                  <div className="w-[10rem]">
                    <PrimaryButton onClick={viewModel.handleRelatorio}>
                      Gerar relatório
                    </PrimaryButton>
                  </div>
                )}
                {viewModel.isCreated && (
                  <div className="w-[170px]">
                    <PrimaryButton
                      startIcon={
                        <DynamicIcon
                          nameIcon="AddRounded"
                          size={25}
                          className="text-white"
                        />
                      }
                      onMouseDown={(e) => {
                        viewModel.handleNewFuncionario();
                        e.preventDefault();
                      }}
                    >
                      Novo Funcionário
                    </PrimaryButton>
                  </div>
                )}
                <div>
                  <BackButton onClick={viewModel.handleBack} />
                </div>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
       * Page
       */}

      <form className="pb-8" onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              RH
            </Link>
            <Link underline="hover" color="inherit" component={"span"}>
              <LinkTo to="/Funcionarios_lista">Funcionários</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Funcionário
            </Typography>
          </Breadcrumbs>

          <div>
            <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
              <div className="flex gap-2 items-center w-full">
                <h1 className="text-3xl font-medium text-black dark:text-white">
                  Cadastro de Funcionário
                </h1>
                <RefreshButton onClick={viewModel.handleReloadPage} />
              </div>

              <div className="w-full justify-end flex gap-2"></div>
            </div>
          </div>
          {viewModel.errorMessage !== undefined ? (
            <div className="w-full">
              <AlertError
                messageErro={viewModel.errorMessage}
                onTryAgain={viewModel.handleReloadPage}
              />
            </div>
          ) : (
            <div className="relative bg-transparent">
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  slotProps={{
                    startScrollButtonIcon: {
                      className: "text-black dark:text-white",
                    },
                    endScrollButtonIcon: {
                      className: "text-black dark:text-white",
                    },
                    indicator: {
                      style: {
                        background: "#009C4E",
                      },
                    },
                  }}
                  value={viewModel.currentTab}
                  onChange={viewModel.handleTabChange}
                >
                  <Tab
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": {
                        color: "#009C4E",
                      },
                    }}
                    label="Informações Gerais"
                    value={1}
                  />

                  <Tab
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": {
                        color: "#009C4E",
                      },
                    }}
                    disabled={!viewModel.isCreated}
                    label="Documentos/Comprovantes"
                    value={2}
                  />

                  <Tab
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": {
                        color: "#009C4E",
                      },
                    }}
                    disabled={!viewModel.isCreated}
                    label="Treinamentos"
                    value={3}
                  />

                  <Tab
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": {
                        color: "#009C4E",
                      },
                    }}
                    disabled={!viewModel.isCreated}
                    label="Habilidades"
                    value={4}
                  />

                  <Tab
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": {
                        color: "#009C4E",
                      },
                    }}
                    disabled={!viewModel.isCreated}
                    label="Controle de Patrimônio "
                    value={5}
                  />
                  <Tab
                    sx={{
                      textTransform: "none",
                      "&.Mui-selected": {
                        color: "#009C4E",
                      },
                    }}
                    disabled={!viewModel.isCreated}
                    label="Biometria facial "
                    value={6}
                  />
                </Tabs>
              </Box>
              {viewModel.currentTab === 1 && (
                <TabInformacoesGeraisContent
                  loading={viewModel.loading}
                  isCreated={viewModel.isCreated}
                  funcionario={viewModel.funcionario}
                  fileUpload={viewModel.fileUpload}
                  centroCustoLista={viewModel.filters.centroCustoLista ?? []}
                  motivosDemissaoLista={viewModel.filters.motivosDemissaoDropDownLista ?? []}
                  hookForm={viewModel.hookForm}

                  onStartFileUpload={viewModel.handleStartFileUpload}
                  onDeleteFileUpload={viewModel.handleDeleteFileUpload}
                  onLoadCep={viewModel.handleLoadCep}
                  onCreateCentroCusto={viewModel.handleCreateInformacoesGeraisCentroCusto}
                  onCreateMotivoDemissao={viewModel.handleCreateMotivoDemissao}

                  // Centro de custo secundario.

                  onSetCadastroCentroCustoSecundarioOpenState={viewModel.handleCadastroCentroCustoSecundarioOpenState}
                  onStartDeleteCentroCustoSecundario={viewModel.handleDeletarCentroCustoSecundarioOpenState}
                  centroCustoSecundarioPage={viewModel.pagination.centroCustoSecundarios.page}
                  centroCustoSecundarioRowsPerPage={viewModel.pagination.centroCustoSecundarios.rowsPerPage}
                  centroCustoSecundarioTotalItems={viewModel.pagination.centroCustoSecundarios.totalItems}
                  centroCustoSecundarioLista={viewModel.centroCustoSecundarios}
                  onCentroCustoSecundarioPageChange={viewModel.handleCentroCustoSecundarioPageChange}
                  onCentroCustoSecundarioRowsPerPageChange={viewModel.handleCentroCustoSecundarioRowsPerPageChange}

                  // Dependentes

                  onSetCadastroDependenteOpenState={
                    viewModel.handleCadastroDependenteOpenState
                  }
                  onStartDeleteDependente={
                    viewModel.handleDeletarDependenteOpenState
                  }
                  dependentesPage={viewModel.pagination.dependentes.page}
                  dependentesRowsPerPage={
                    viewModel.pagination.dependentes.rowsPerPage
                  }
                  dependentesTotalItems={
                    viewModel.pagination.dependentes.totalItems
                  }
                  dependentesLista={viewModel.dependentes}
                  onDependentesPageChange={
                    viewModel.handleDependentesPageChange
                  }
                  onDependentesRowsPerPageChange={
                    viewModel.handleDependentesRowsPerPageChange
                  }
                  // Eventos

                  onSetCadastroEventoOpenState={
                    viewModel.handleCadastroEventoOpenState
                  }
                  onStartDeleteEvento={viewModel.handleDeletarEventoOpenState}
                  eventosPage={viewModel.pagination.eventos.page}
                  eventosRowsPerPage={viewModel.pagination.eventos.rowsPerPage}
                  eventosTotalItems={viewModel.pagination.eventos.totalItems}
                  eventosLista={viewModel.eventos}
                  onEventosPageChange={viewModel.handleEventosPageChange}
                  onEventosRowsPerPageChange={
                    viewModel.handleEventosRowsPerPageChange
                  }
                  // Ferias

                  onSetCadastroFeriasOpenState={
                    viewModel.handleCadastroFeriasOpenState
                  }
                  onStartDeleteFerias={viewModel.handleDeletarFeriasOpenState}
                  feriasPage={viewModel.pagination.ferias.page}
                  feriasRowsPerPage={viewModel.pagination.ferias.rowsPerPage}
                  feriasTotalItems={viewModel.pagination.ferias.totalItems}
                  feriasLista={viewModel.ferias}
                  onFeriasPageChange={viewModel.handleFeriasPageChange}
                  onFeriasRowsPerPageChange={
                    viewModel.handleFeriasRowsPerPageChange
                  }
                  // Afastamento

                  onSetCadastroAfastamentoOpenState={
                    viewModel.handleCadastroAfastamentoOpenState
                  }
                  onStartDeleteAfastamento={
                    viewModel.handleDeletarAfastamentoOpenState
                  }
                  afastamentosPage={viewModel.pagination.afastamentos.page}
                  afastamentosRowsPerPage={
                    viewModel.pagination.afastamentos.rowsPerPage
                  }
                  afastamentosTotalItems={
                    viewModel.pagination.afastamentos.totalItems
                  }
                  afastamentosLista={viewModel.afastamentos}
                  onAfastamentoPageChange={
                    viewModel.handleAfastamentoPageChange
                  }
                  onAfastamentoRowsPerPageChange={
                    viewModel.handleAfastamentoRowsPerPageChange
                  }
                />
              )}
              {viewModel.currentTab === 2 && (
                <TabDocumentosContent
                  loading={viewModel.loading}
                  hookForm={viewModel.hookForm}
                  documentos={viewModel.documentos}
                  documentosEntregues={viewModel.documentosEntregues}
                  documentosPage={viewModel.pagination.documentos.page}
                  documentosRowsPerPage={
                    viewModel.pagination.documentos.rowsPerPage
                  }
                  documentosTotalItems={
                    viewModel.pagination.documentos.totalItems
                  }
                  documentosEntreguesPage={
                    viewModel.pagination.documentosEntregues.page
                  }
                  documentosEntreguesRowsPerPage={
                    viewModel.pagination.documentosEntregues.rowsPerPage
                  }
                  documentosEntreguesTotalItems={
                    viewModel.pagination.documentosEntregues.totalItems
                  }
                  onDocumentosPageChange={viewModel.handleDocumentosPageChange}
                  onDocumentosRowsPerPageChange={
                    viewModel.handleDocumentosRowsPerPageChange
                  }
                  onDocumentosEntreguesPageChange={
                    viewModel.handleDocumentosEntreguesPageChange
                  }
                  onDocumentosEntreguesRowsPerPageChange={
                    viewModel.handleDocumentosEntreguesRowsPerPageChange
                  }
                  onSetCadastroDocumentoModalOpenState={(id) =>
                    viewModel.handleCadastroDocumentoOpenState(id, true)
                  }
                  onSetDeletarDocumentoModalOpenState={(id) =>
                    viewModel.handleDeletarDocumentoOpenState(id, true)
                  }
                  onDeleteAllDocumentos={
                    viewModel.handleDeletarAllDocumentosOpenState
                  }
                  onDownload={viewModel.handleDownloadDocumento}
                  onDownloadAllDocumentos={
                    viewModel.handleFuncionarioGetAllDocumentos
                  }
                />
              )}

              {viewModel.currentTab === 3 && (
                <TabTreinamentosContent
                  loading={viewModel.loading}
                  treinamentosPage={viewModel.pagination.treinamentos.page}
                  treinamentosRowsPerPage={viewModel.pagination.treinamentos.rowsPerPage}
                  treinamentosTotalItems={viewModel.pagination.treinamentos.totalItems}
                  treinamentosLista={viewModel.funcionarioTreinamentos}
                  onPageChange={viewModel.handleFuncionarioTreinamentosPageChange}
                  onRowsPerPageChange={viewModel.handleFuncionarioTreinamentosRowsPerPageChange}
                  onCadastrar={viewModel.handleCadastroFuncionarioTreinamentoOpenState}
                  onAvaliar={viewModel.handleAvaliarFuncionarioTreinamentoOpenState}
                  onAvaliarLote={viewModel.handleAvaliarLoteTreinamentoOpenState}
                  onExportar={viewModel.handleRelatorioFuncionarioTreinamentoOpenState}
                  onCertificate={viewModel.handleCertificadoFuncionarioTreinamentoSubmit}
                  onEditar={viewModel.handleEditarFuncionarioTreinamento}
                  onDeletar={viewModel.handleDeletarFuncionarioTreinamentoOpenState}
                  onDeletarLote={viewModel.handleDeletarTreinamentosLoteOpenState}
                />
              )}

              {viewModel.currentTab === 4 && (
                <TabHabilidadesContent
                  loading={viewModel.loading}
                  habilidadesPage={viewModel.pagination.habilidades.page}
                  habilidadesRowsPerPage={
                    viewModel.pagination.habilidades.rowsPerPage
                  }
                  habilidadesTotalItems={
                    viewModel.pagination.habilidades.totalItems
                  }
                  habilidadesLista={viewModel.habilidades}
                  onHabilidadesPageChange={
                    viewModel.handleHabilidadesPageChange
                  }
                  onHabilidadesRowsPerPageChange={
                    viewModel.handleHabilidadesRowsPerPageChange
                  }
                  onCadastrarHabilidade={
                    viewModel.handleCadastroHabilidadeOpenState
                  }
                  onExportar={
                    viewModel.handleRelatorioAvaliacaoHabilidadeOpenState
                  }
                  onEditar={viewModel.handleCadastroHabilidadeOpenState}
                  onDeletar={viewModel.handleDeletarHabilidadeOpenState}
                />
              )}
              {viewModel.currentTab === 5 && (
                <TabControlePatrimonioContent
                  loading={viewModel.loading}
                  controlePatrimonios={viewModel.controlePatrimonios}
                  controlePatrimonioPage={
                    viewModel.pagination.controlePatrimonios.page
                  }
                  controlePatrimonioRowsPerPage={
                    viewModel.pagination.controlePatrimonios.rowsPerPage
                  }
                  controlePatrimonioTotalCount={
                    viewModel.pagination.controlePatrimonios.totalItems
                  }
                  onControlePatrimonioPageChange={
                    viewModel.handleControlePatrimonioPageChange
                  }
                  onControlePatrimonioRowsPerPageChange={
                    viewModel.handleControlePatrimonioRowsPerPageChange
                  }
                  onCadastrarControlePatrimonio={
                    viewModel.handleCadastroControlePatrimonioOpenState
                  }
                  onEditarControlePatrimonio={
                    viewModel.handleCadastroControlePatrimonioOpenState
                  }
                  onDeletarControlePatrimonio={
                    viewModel.handleDeletarControlePatrimonioOpenState
                  }
                />
              )}
              {viewModel.currentTab === 6 && (
                <TabBiometriaFacialContent
                  loading={viewModel.loading}
                  biometriaFacial={viewModel.biometriaFacial}
                  biometriaFacialPage={
                    viewModel.pagination.biometriaFacial.page
                  }
                  biometriaFacialRowsPerPage={
                    viewModel.pagination.biometriaFacial.rowsPerPage
                  }
                  biometriaFacialTotalCount={
                    viewModel.pagination.biometriaFacial.totalItems
                  }
                  onBiometriaFacialPageChange={
                    viewModel.handleBiometriaFacialPageChange
                  }
                  onBiometriaFacialRowsPerPageChange={
                    viewModel.handleBiometriaFacialRowsPerPageChange
                  }
                  onCadastrarBiometriaFacial={
                    viewModel.handleCadastroBiometriaFacialOpenState
                  }
                  onDeletarBiometriaFacial={
                    viewModel.handleDeletarBiometriaFacialOpenState
                  }
                  onActionVisualize={viewModel.handleActionVisualize}
                  onActionAuditoria={viewModel.handleActionAuditoria}
                />
              )}
            </div>
          )}
        </div>

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.idFuncionario) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleCancel}
                >
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
       * Modals Informações Gerais
       */}

      <CadastroCentroCustoSecundarioModal
        selectedCentroCustoSecundario={
          viewModel.selectedCentroCustoSecundario ?? null
        }
        open={viewModel.openCadastroCentroCustoSecundarioModal}
        saving={viewModel.saving}
        centroCustoLista={viewModel.filters.centroCustoLista ?? []}
        onSubmit={viewModel.handleSubmitCentroCustoSecundario}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onClose={() =>
          viewModel.handleCadastroCentroCustoSecundarioOpenState(null, false)
        }
        onCreateCentroCusto={viewModel.handleCreateSecundarioCentroCusto}
      />

      <CadastroDependenteModal
        saving={viewModel.saving}
        open={viewModel.openCadastroDependenteModal}
        selectedDependente={viewModel.selectedDependente ?? null}
        onSubmit={viewModel.handleSubmitDependente}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onClose={() => viewModel.handleCadastroDependenteOpenState(null, false)}
      />

      <CadastroEventoModal
        open={viewModel.openCadastroEventoModal}
        saving={viewModel.saving}
        selectedEvento={viewModel.selectedEvento ?? null}
        itensVerbaDropDown={viewModel.filters.itensVerbaDropDownLista ?? []}
        onSubmit={viewModel.handleSubmitEvento}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onNovoItemVerba={() => { }}
        onClose={() => viewModel.handleCadastroEventoOpenState(null, false)}
      />

      <CadastroFeriasModal
        open={viewModel.openCadastroFeriasModal}
        saving={viewModel.saving}
        selectedFerias={viewModel.selectedFerias ?? null}
        onSubmit={viewModel.handleSubmitFerias}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onClose={() => viewModel.handleCadastroFeriasOpenState(null, false)}
      />

      <CadastroAfastamentoModal
        open={viewModel.openCadastroAfastamentoModal}
        saving={viewModel.saving}
        selectedAfastamento={viewModel.selectedAfastamento ?? null}
        motivosAfastamento={viewModel.filters.motivosAfastamentoLista ?? []}
        onSubmit={viewModel.handleSubmitAfastamento}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onNewMotivoAfastamento={() => { }}
        onClose={() =>
          viewModel.handleCadastroAfastamentoOpenState(null, false)
        }
      />

      <DeleteDialog
        open={viewModel.openDeletarCentroCustoSecundarioModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeletarCentroCustoSecundarioOpenState(null, false)
        }
        title={`Você realmente deseja excluir este centro de custo secundário?`}
        onDelete={() => viewModel.handleConfirmarDeletarCentroCustoSecundario()}
      />

      <DeleteDialog
        open={viewModel.openInativarBiometriaModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeletarBiometriaFacialOpenState(null, false)
        }
        title={`Você realmente deseja inativar esta biometria facial?`}
        onDelete={() => viewModel.handleConfirmarInativarBiometria()}
      />

      <DeleteDialog
        open={viewModel.openDeletarDependenteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarDependenteOpenState(null, false)}
        title={`Você realmente deseja excluir este dependente?`}
        onDelete={() => viewModel.handleConfirmarDeletarDependente()}
      />

      <DeleteDialog
        open={viewModel.openDeletarEventoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarEventoOpenState(null, false)}
        title={`Você realmente deseja excluir este evento?`}
        onDelete={() => viewModel.handleConfirmarDeletarEvento()}
      />

      <DeleteDialog
        open={viewModel.openDeletarFeriasModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarFeriasOpenState(null, false)}
        title={`Você realmente deseja excluir este ferias?`}
        onDelete={() => viewModel.handleConfirmarDeletarFerias()}
      />

      <DeleteDialog
        open={viewModel.openDeletarAfastamentoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarAfastamentoOpenState(null, false)}
        title={`Você realmente deseja excluir este afastamento?`}
        onDelete={() => viewModel.handleConfirmarDeletarAfastamento()}
      />

      {/**
       * Modals Documentos
       */}

      <CadastroDocumentoModal
        open={viewModel.openCadastroDocumentoModal}
        saving={viewModel.saving}
        selectedDocumento={viewModel.selectedDocumento ?? null}
        onSubmit={viewModel.handleSubmitDocumento}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onDownload={viewModel.handleDownloadDocumento}
        onClose={() => viewModel.handleCadastroDocumentoOpenState(null, false)}
      />

      <DeleteDialog
        open={viewModel.openDeletarDocumentoModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarDocumentoOpenState(null, false)}
        title={`Você realmente deseja excluir este documento?`}
        onDelete={() => viewModel.handleConfirmarDeletarDocumento()}
      />

      <DeleteDialog
        open={viewModel.openDeletarAllDocumentosModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarAllDocumentosOpenState(false)}
        title={`Você realmente deseja excluir todos os documento?`}
        onDelete={() => viewModel.handleConfirmarDeletarAllDocumentos()}
      />

      {/**
       * Modals Treinamentos
       */}

      <CadastroTreinamentoModal
        open={viewModel.openCadastroFuncionarioTreinamentoModal}
        saving={viewModel.saving}
        selectedTreinamento={viewModel.selectedFuncionarioTreinamento ?? null}
        treinamentoLista={viewModel.filters.treinamentoLista ?? []}
        onSubmit={viewModel.handleSubmitTreinamento}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onClose={() =>
          viewModel.handleCadastroFuncionarioTreinamentoOpenState(null, false)
        }
      />

      <AvaliarTreinamentoModal
        open={viewModel.openAvaliarFuncionarioTreinamentoModal}
        saving={viewModel.saving}
        selectedTreinamento={viewModel.selectedFuncionarioTreinamento ?? null}
        onSubmit={viewModel.handleSubmitAvaliarTreinamento}
        onClose={() =>
          viewModel.handleAvaliarFuncionarioTreinamentoOpenState(null, false)
        }
      />

      <RelatorioTreinamentoModal
        open={viewModel.openRelatorioFuncionarioTreinamentoModal}
        selectedFuncionarioTreinamento={
          viewModel.selectedFuncionarioTreinamento ?? null
        }
        funcionarioAssinaturas={
          viewModel.filters.funcionarioAssinaturasDropDownLista ?? []
        }
        onSubmit={viewModel.handleSubmitRelatorioFuncionarioTreinamento}
        onClose={viewModel.handleRelatorioFuncionarioTreinamentoOpenState}
      />

      {/*
      <CertificadoTreinamentoModal
        open={viewModel.openCertificadoFuncionarioTreinamentoModal}
        selectedFuncionarioTreinamento={viewModel.selectedFuncionarioTreinamento ?? null}
        funcionarioAssinaturas={viewModel.filters.funcionarioAssinaturasDropDownLista ?? []}
        onSubmit={viewModel.handleCertificadoFuncionarioTreinamentoSubmit}
        onClose={viewModel.handleCertificadoFuncionarioTreinamentoOpenState}
      />
      */}

      <DeleteDialog
        open={viewModel.openDeletarFuncionarioTreinamentoModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeletarFuncionarioTreinamentoOpenState(null, false)
        }
        title={`Você realmente deseja excluir este treinamento?`}
        onDelete={() =>
          viewModel.handleConfirmarDeletarFuncionarioTreinamento()
        }
      />

      <DeleteDialog
        open={viewModel.openDeletarFuncionarioTreinamentosLoteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeletarFuncionarioTreinamentoOpenState(null, false)
        }
        title={`Você realmente deseja excluir os treinamentos selecionados?`}
        onDelete={() =>
          viewModel.handleConfirmarDeletarFuncionarioTreinamentosLote()
        }
      />

      {/**
       * Modals Habilidade
       */}

      <CadastroHabilidadeModal
        open={viewModel.openCadastroHabilidadeModal}
        saving={viewModel.saving}
        selectedHabilidade={viewModel.selectedHabilidade}
        funcionarios={viewModel.filters.funcionarioLista ?? []}
        habilidadeItems={viewModel.selectedHabilidadeItems}
        habilidadeItemsPage={viewModel.pagination.habilidadeItems.page}
        habilidadeItemsRowsPerPage={
          viewModel.pagination.habilidadeItems.rowsPerPage
        }
        habilidadeItemsTotalSize={
          viewModel.pagination.habilidadeItems.totalItems
        }
        onSubmit={viewModel.handleSubmitAvaliarHabilidade}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onClose={() => viewModel.handleCadastroHabilidadeOpenState(null, false)}
        onCadastrarHabilidadeItem={() =>
          viewModel.handleCadastroHabilidadeItemOpenState(null, true)
        }
        onHabilidadeItemsPageChange={viewModel.handleHabilidadeItemsPageChange}
        onEditActionHabilidadeItem={
          viewModel.handleCadastroHabilidadeItemOpenState
        }
        onDeleteActionHabilidadeItem={
          viewModel.handleDeletarHabilidadeItemOpenState
        }
      />

      <CadastroHabilidadeItemModal
        open={viewModel.openCadastroHabilidadeItemModal}
        saving={viewModel.saving}
        habilidades={viewModel.filters.avaliacaoHabilidadesLista ?? []}
        selectedHabilidadeItem={viewModel.selectedHabilidadeItem}
        onSubmit={viewModel.handleSubmitAvaliarHabilidadeItem}
        onClose={() =>
          viewModel.handleCadastroHabilidadeItemOpenState(null, false)
        }
      />

      <DeleteDialog
        open={viewModel.openDeletarHabilidadeModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeletarHabilidadeOpenState(null, false)}
        title={`Você realmente deseja excluir esta habilidade?`}
        onDelete={() => viewModel.handleConfirmarDeletarHabilidade()}
      />

      <DeleteDialog
        open={viewModel.openDeletarHabilidadeItemModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeletarHabilidadeItemOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item de habilidade?`}
        onDelete={() => viewModel.handleConfirmarDeletarHabilidadeItem()}
      />

      {/**
       * Modals Controle de patrimonio
       */}

      <CadastroControlePatrimonioModal
        open={viewModel.openCadastroControlePatrimonioModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        equipamentoLista={viewModel.filters.equipamentoLista ?? []}
        selectedControlePatrimonio={
          viewModel.selectedControlePatrimonio ?? null
        }
        onSubmit={viewModel.handleSubmitControlePatrimonio}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onDownload={viewModel.handleDownloadControlePatrimonio}
        onClose={viewModel.handleCadastroControlePatrimonioOpenState}
      />

      <CadastroBiometriaFacialModal
        open={viewModel.openCadastroBiometriaFacialModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionario={viewModel.funcionario as any}
        selectedBiometriaFacial={viewModel.selectedBiometriaFacial ?? null}
        onSubmit={viewModel.handleSubmitBiometriaFacial}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        onClose={viewModel.handleCadastroBiometriaFacialOpenState}
        ddlTermos={viewModel.termoEpiLista ?? []}
      />

      <VisualizacaoGryfoAuditaModal
        open={viewModel.gryfoAuditOpen}
        loading={viewModel.loading}
        imagemUrl={viewModel.imagemUrl}
        onClose={viewModel.handleCloseModalGryfoAudit}
        auditoriaGryfo={viewModel.selectedGryfoAudit ?? null}
        selectedTermo={viewModel.selectedTermo ?? null}
      />

      <VisualizacaoBiometriaModal
        open={viewModel.modalImagemOpen}
        loading={viewModel.loading}
        imagemUrl={viewModel.imagemUrl}
        onClose={viewModel.handleCloseModalImagem}
        selectedBiometria={viewModel.selectedBiometriaFacial ?? null}
        selectedFuncionario={viewModel.funcionario}
      />

      <DeleteDialog
        open={viewModel.openDeletarControlePatrimonioModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeletarControlePatrimonioOpenState(null, false)
        }
        title={`Você realmente deseja excluir este controle de patrimônio?`}
        onDelete={() => viewModel.handleConfirmarDeletarControlePatrimonio()}
      />

      {/**
       * Modal historico de alterações.
       */}

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />

      {/**
       * Report viewer
       */}

      <ReportViewerModal reportViewerState={viewModel.reportViewerState} />

      {/**
       * Drawer
       */}

      <CentroCustoDrawer
        state={viewModel.centroCustoDrawerState}
        saving={viewModel.saving}
      />

      <MotivoDemissaoDrawer
        state={viewModel.motivoDemissaoDrawerState}
        saving={viewModel.saving}
      />

      {/**
        * Job viewer
        */}

      <JobWaiterModal
        open={viewModel.openJobWaiterModel}
        onClose={() => viewModel.handleJobWaiterOpenState(false)}
        onUpdateJobStatus={viewModel.handleUpdateJobStatus}
        onError={viewModel.handleJobStatusError}
      />

    </>
  );
};
